module.exports = __webpack_public_path__ + "static/media/0323_IMG_LE_FROMAGER_KIOSQUE.490df24e.webp";